module.exports = __webpack_public_path__ + "img/ew-icon_dashboard.de62f906.svg";